import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa736c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "family-dot" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SpouseConnector',
  props: {
    dimmed: { type: Boolean },
    layout: {}
  },
  setup(__props: any) {

const props = __props;



const layoutRef = computed(() => props.layout || 'full')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spouse-connector", { dimmed: props.dimmed, ['connector-' + layoutRef.value]: true }])
  }, _hoisted_2, 2))
}
}

})